import { createContext } from "react"
import { PricingPageContextClass } from "./models/PricingPageContextClass"
import { CustomerContextType } from "./types/CustomerContextType"

export const CustomerContext = createContext<CustomerContextType | null>(null)
export const PricingPageContext = createContext<PricingPageContextClass | null>(null)